import { gsap, ScrollTrigger } from "@/composeables/gsap"

function animateText(self) {
    let { trigger, direction } = self
    const v = Math.abs(self.getVelocity())

    if (direction === 0 || v === 0) {
        return;
    }

    const qs = gsap.utils.selector(trigger)
    const formula = 0.6 / Math.log2(v + 1) || 1;
    const duration = Math.max(0.01, Math.min(formula, 0.1))

    const textElements = qs(".text > *")
    const x = 0
    const y = direction * 100

    gsap.set(textElements, {
        autoAlpha: 0,
        x: x,
        y: y,
        willChange: "transform, opacity"
    })

    const tween = gsap.fromTo(
        textElements,
        { x: x, y: y, autoAlpha: 0 },
        { x: 0, y: 0, autoAlpha: 1,
            ease: "expo",
            overwrite: "auto",
            stagger: {
                each: duration,
                from: direction >= 0 ? "start" : "end"
            },
            duration: 1,
            onComplete: () => { gsap.set(textElements, { clearProps: 'all' })}
        }
    )
}

function hideText({ trigger }) {
    const qs = gsap.utils.selector(trigger)

    const textElements = qs(".text > *")

    gsap.set(textElements, {
        autoAlpha: 0,
        willChange: "transform, opacity",
        overwrite: "auto",
        clearProps: 'transform',
    })
}
function createSectionAnimation(section) {

    ScrollTrigger.create({
        trigger: section,
        markers: false,
        start: "top bottom",
        end: "bottom top",
        invalidateOnRefresh: true,
        onEnter: (self) =>{ animateText(self) },
        onLeave: (self) => { hideText(self) },
        onEnterBack: (self) => { animateText(self) },
        onLeaveBack: (self) => { hideText(self) },
    });


}

export const init = () => {
    const sections = gsap.utils.toArray(".section-text")

    sections
        .forEach(createSectionAnimation);
};

export default init;
